import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-462fd850"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pagination-center",
  "aria-label": "navigation"
}
const _hoisted_2 = { class: "pagination" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-right",
  "aria-hidden": "true"
}, null, -1))

import { toRefs } from 'vue'

  import { IPagination } from '@/types/api'
  import { TWorkoutsPayload } from '@/types/workouts'
  import { rangePagination } from '@/utils/api'

  interface Props {
    pagination: IPagination
    path: string
    query: TWorkoutsPayload
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    pagination: null,
    path: null,
    query: null
  },
  setup(__props: any) {

const props = __props as {
    pagination: IPagination
    path: string
    query: TWorkoutsPayload
  }

  

  const { pagination, path, query } = toRefs(props)

  function getQuery(page: number, cursor?: number): TWorkoutsPayload {
    const newQuery = Object.assign({}, query.value)
    newQuery.page = cursor ? page + cursor : page
    return newQuery
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-prev", { disabled: !_unref(pagination).has_prev }])
      }, [
        _createVNode(_component_router_link, {
          class: "page-link",
          to: { path: _unref(path), query: getQuery(_unref(pagination).page, -1) },
          event: _unref(pagination).has_prev ? 'click' : '',
          disabled: !_unref(pagination).has_prev
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('api.PAGINATION.PREVIOUS')), 1)
          ]),
          _: 1
        }, 8, ["to", "event", "disabled"])
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rangePagination)(_unref(pagination).pages, _unref(pagination).page), (page) => {
        return (_openBlock(), _createElementBlock("li", {
          key: page,
          class: _normalizeClass(["page", { active: page === _unref(pagination).page }])
        }, [
          (page === '...')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " ... "))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "page-link",
                to: { path: _unref(path), query: getQuery(+page) }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(page), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
        ], 2))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["page-next", { disabled: !_unref(pagination).has_next }])
      }, [
        _createVNode(_component_router_link, {
          class: "page-link",
          to: { path: _unref(path), query: getQuery(_unref(pagination).page, 1) },
          event: _unref(pagination).has_next ? 'click' : '',
          disabled: !_unref(pagination).has_next
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('api.PAGINATION.NEXT')) + " ", 1),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to", "event", "disabled"])
      ], 2)
    ])
  ]))
}
}

})